var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#Y';
                    var viewUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#view-Y';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };